export const siteInfo = {
  name: "131吃瓜",
  tagline: "实锤证据合集",
  slogan: "不听单方讲故事，直接翻证据汇总栏",
  description:
    "131吃瓜把实锤证据与证据合集集中放在一起，包括截图、录音等可见素材，按事件类型分类整理，方便对照前后说法。",
  email: "hello@131chigua.com",
  replyNote: "工作日 24 小时内回复，节假日顺延",
  since: "2023 年",
};

export const siteStats = [
  { value: "126", label: "收录事件", suffix: "+" },
  { value: "3,480", label: "证据条目", suffix: "条" },
  { value: "18", label: "今日更新", suffix: "条" },
  { value: "98", label: "来源已标注", suffix: "%" },
];